import { createFileRoute, redirect } from "@tanstack/react-router";
import { resolveLegacyAuthor } from "@/lib/seo/legacyPaths.functions";

export const Route = createFileRoute("/_app/news-author/$slug")({
  loader: async ({ params }) => {
    const author = await resolveLegacyAuthor({ data: params.slug });
    if (author) {
      throw redirect({ to: "/authors/$slug", params: { slug: author }, statusCode: 301 });
    }
    throw redirect({ to: "/news", statusCode: 301 });
  },
  component: () => null,
});
